export default __webpack_public_path__ + "static/media/email-sucess.c030a672.png";